function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { StudentApplicationPage as LegacyStudentApplicationPage } from '@applyboard/ab-application-legacy';
import { ProgressIndicator, Flex, Text } from '@applyboard/crystal-ui';
import { LegacySidebar } from "./components/LegacySidebar";
import { SideBar, SidebarProvider, SideBarCard } from "./components/SideBar";
import { Redirect, Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import { useEventTracker, useTrackViewEvent, useTranslation } from '@applyboard/ui-utils';
import { ApplicationDetailPageDataProvider, useApplicationPageInitialProps, useApplicationRequirementEvaluationStatus, useLegacyApplicationRequirements, useFeatureFlags, useIsNewLayoutEnabled, useApplicationRequirements } from "./data";
import { HttpError } from "../../utils/error";
import { useApplication } from "./data/application";
import { LegacyApplicationStepper } from "./components/LegacyApplicationStepper";
import { VerificationResults } from "./components/VerificationResults";
import { DocumentVerificationModal } from "../../components/DocumentVerificationModal";
import { RPSelfEvaluation } from "./components/RPSelfEvaluation";
import { useReloadApplicationPageAggregatedData } from "./data/aggregatedData";
import { LegacyRemoveFileDialog } from "./components/LegacyRemoveFileDialog";
import { RecommendedProgramsDialogLoader } from "./components/RecommendedProgramsDialog";
import { HybridRequirementDecisionReasons } from "./components/HybridRequirementDecisionReasons";
import { HybridRequirementDialogButton } from "./components/HybridRequirementDialogButton";
import { HybridRequirementPreviewMode } from "./components/HybridRequirementPreviewMode";
import { ActionsMenu } from "./components/ActionsMenu";
import { useApplicationPagePermissions } from "./data/permissions";
import { RequirementList } from "./components/RequirementList";
import { IllustratedErrorState } from "../../components/IllustratedErrorState";
import { NewViewNotice } from "./components/NewViewNotice";
import { NewViewAdminToggle } from "./components/NewViewAdminToggle";
import { assert } from "../../utils/assert";
import { NotesList } from "./components/NotesList";
import { Header } from "./components/Header";
import { ManageApplicationButton } from "./components/ManageApplicationButton";
import { ProvideAnswersButton } from "./components/RequirementList/ApplicationRequirementCard/ProvideAnswersButton";
import { ApplicationStepperCard } from "./components/ApplicationStepper";
import { StudentApplicationPageLayout, useCanCreateBulkNote } from "./StudentApplicationPageLayout";
import { ApplicationPageTracker } from "./components/ApplicationPageTracker";
import { useNotes } from "./data/notes";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
StudentApplicationPage.SideBar = SideBar;
StudentApplicationPage.Header = Header;
StudentApplicationPage.ManageApplicationButton = ManageApplicationButton;
export function StudentApplicationPage(props) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var applicationId = Number(props.match.params.application_id);
  useTrackViewEvent({
    event: 'Single Application - View Application Page',
    data: {
      applicationId: applicationId
    }
  });
  return _jsx(ErrorBoundary, {
    onError: function onError(error) {
      return trackEvent({
        event: 'Student Application - View Page Error',
        error: error
      });
    },
    fallbackRender: function fallbackRender(_ref) {
      var error = _ref.error;
      return _jsx(IllustratedErrorState, {
        error: error,
        appName: props.appName
      });
    },
    children: _jsx(ApplicationDetailPageDataProvider, {
      applicationId: applicationId,
      children: _jsx(StudentApplicationPageLoader, {
        appName: props.appName,
        match: props.match,
        RemoveFileDialog: props.RemoveFileDialog,
        header: props.header,
        sidebar: props.sidebar,
        showNotesTakeActionMenu: props.showNotesTakeActionMenu,
        onStartLiveChat: props.onStartLiveChat
      })
    })
  });
}
function StudentApplicationPageLoader(props) {
  var history = useHistory();
  var _useApplicationPageIn = useApplicationPageInitialProps({
      onError: function onError(err) {
        if (err instanceof HttpError && err.httpCode === 401) {
          history.push('/401');
        }
      }
    }),
    isFetched = _useApplicationPageIn.isFetched;
  if (!isFetched) {
    return _jsx(Flex, {
      justify: "center",
      children: _jsx(ProgressIndicator, {
        size: "lg",
        variant: "circular",
        indeterminate: true,
        "aria-label": "Loading application..."
      })
    });
  }
  return _jsxs(Switch, {
    children: [_jsx(Route, {
      path: "/applications/:application_id/requirements/:requirement_id/form",
      render: function render(props) {
        return _jsx(ProvideAnswersButton, {
          requirementId: props.match.params.requirement_id,
          defaultOpen: true,
          fullScreen: true
        });
      }
    }), _jsx(Route, {
      children: _jsx(StudentApplicationPageLayoutSwitcher, _objectSpread({}, props))
    })]
  });
}
function StudentApplicationPageLayoutSwitcher(props) {
  var isNewLayoutEnabled = useIsNewLayoutEnabled();
  var _useApplicationRequir = useApplicationRequirements(),
    applicationRequirements = _useApplicationRequir.applicationRequirements;
  var _useNotes = useNotes(),
    applicationNotes = _useNotes.applicationNotes;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var location = useLocation();
  var params = useParams();
  var _useFeatureFlags = useFeatureFlags(),
    featureFlags = _useFeatureFlags.featureFlags;
  var searchParams = new URLSearchParams(location.search);
  var tab = searchParams.get('tab');
  if (featureFlags['application_apr_notes']) {
    var legacyNoteId = searchParams.get('note_id');
    if (tab === 'notes' || tab === 'admin-comments') {
      var note = applicationNotes.find(function (note) {
        return note.legacyId.toString() === legacyNoteId && note.type === (tab === 'notes' ? 'application_customer_note' : 'application_admin_note');
      });
      if (note) {
        return _jsx(Redirect, {
          to: "/applications/".concat(application.legacyId, "/").concat(tab, "#").concat(note.id)
        });
      }
      return _jsx(Redirect, {
        to: "/applications/".concat(application.legacyId, "/").concat(tab)
      });
    }
  } else {
    if (location.pathname.includes('notes') || location.pathname.includes('admin-comments')) {
      var _tab = location.pathname.includes('notes') ? 'notes' : 'admin-comments';
      return _jsx(Redirect, {
        to: "/applications/".concat(params.application_id, "?tab=").concat(_tab)
      });
    }
  }

  // TODO: Remove this after migrating all users to new requirement view
  // See: https://applyboard.slack.com/archives/C02F4DWK99U/p1724787202601109?thread_ts=1724786145.083519&cid=C02F4DWK99U
  if (application.newView) {
    searchParams["delete"]('tab');
    var queryString = searchParams.toString() ? "?".concat(searchParams.toString()) : '';
    if (location.hash.startsWith('#req-')) {
      var legacyRequirementId = location.hash.replace('#req-', '');
      var requirement = applicationRequirements.find(function (req) {
        return req.legacyId.toString() === legacyRequirementId;
      });
      if (requirement !== null && requirement !== void 0 && requirement.legacyId) {
        var classification = requirement.classification === 'applicant_requirement' ? 'requirements' : 'admin-requirements';
        return _jsx(Redirect, {
          to: "/applications/".concat(application.legacyId, "/").concat(classification, "/").concat(requirement.id).concat(queryString)
        });
      }
    }
    if (tab === 'actions') {
      return _jsx(Redirect, {
        to: "/applications/".concat(application.legacyId, "/admin-requirements").concat(queryString)
      });
    } else if (tab === 'applicant-requirements') {
      return _jsx(Redirect, {
        to: "/applications/".concat(application.legacyId).concat(queryString)
      });
    }
  }
  if (isNewLayoutEnabled) {
    return _jsx(StudentApplicationPageLayout, _objectSpread({}, props));
  }
  return _jsx(LegacyStudentApplicationPageLayout, _objectSpread({}, props));
}
function LegacyStudentApplicationPageLayout(props) {
  var _useFeatureFlags2 = useFeatureFlags(),
    featureFlags = _useFeatureFlags2.featureFlags;
  var _useApplication2 = useApplication(),
    application = _useApplication2.application;
  var _useLegacyApplication = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication.applicationRequirements;
  var _useReloadApplication = useReloadApplicationPageAggregatedData(),
    reloadApplicationPageAggregatedData = _useReloadApplication.reloadApplicationPageAggregatedData;
  var _useParams = useParams(),
    requirementId = _useParams.requirement_id;
  var _useState = useState(!requirementId),
    _useState2 = _slicedToArray(_useState, 2),
    isSidebarOpen = _useState2[0],
    setIsSidebarOpen = _useState2[1];
  var _useApplicationPageIn2 = useApplicationPageInitialProps(),
    initialProps = _useApplicationPageIn2.initialProps;
  var _useApplicationRequir2 = useApplicationRequirementEvaluationStatus(),
    applicationRequirementEvaluationStatus = _useApplicationRequir2.applicationRequirementEvaluationStatus;
  var isRequirementEvaluationPending = (applicationRequirementEvaluationStatus === null || applicationRequirementEvaluationStatus === void 0 ? void 0 : applicationRequirementEvaluationStatus.evaluationStatus) === 'pending';
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var canCreateBulkNote = useCanCreateBulkNote();
  var _useEventTracker2 = useEventTracker(),
    trackEvent = _useEventTracker2.trackEvent;
  var _useTranslation = useTranslation('NotesList'),
    t = _useTranslation.t;
  var showAprActionsTabFeatures = featureFlags['application_apr_actions_tab'];
  var storedViewType = localStorage.getItem('ab-application-newViewType');
  var initialNewView = application.newView && (props.appName !== 'admin' || featureFlags['application_apr_admin_features'] || featureFlags['application_apr_actions_tab'] || storedViewType === 'rp');
  var _useState3 = useState(initialNewView),
    _useState4 = _slicedToArray(_useState3, 2),
    showNewView = _useState4[0],
    setShowNewView = _useState4[1];
  function onChangeView(view) {
    assert(view === 'admin' || view === 'rp');
    localStorage.setItem('ab-application-newViewType', view);
    setShowNewView(view === 'rp' && props.appName === 'admin');
  }
  var showToggle = props.appName === 'admin' && !featureFlags['application_apr_admin_features'] && application.newView;
  var isMarkdownRendererEnabled = !!featureFlags['application_apr_notes'];
  return _jsx(SidebarProvider, {
    isOpen: isSidebarOpen,
    onOpenChange: setIsSidebarOpen,
    children: _jsx(ApplicationPageTracker, {
      applicationId: props.match.params.application_id,
      children: _jsx(LegacyStudentApplicationPage, {
        initialProps: initialProps,
        match: props.match,
        aggregatedDataRequirements: applicationRequirements,
        appName: props.appName,
        RecommendedProgramsDialogLoader: RecommendedProgramsDialogLoader,
        reloadAggregatedData: reloadApplicationPageAggregatedData,
        RemoveFileDialog: LegacyRemoveFileDialog,
        DocumentVerificationModal: DocumentVerificationModal,
        VerificationResults: VerificationResults,
        header: featureFlags['application_apr_page_header'] ? props.header : undefined,
        renderSidebar: function renderSidebar(_ref2) {
          var application = _ref2.application,
            onChangeIntakeSuccess = _ref2.onChangeIntakeSuccess,
            reloadBaseApplication = _ref2.reloadBaseApplication;
          return featureFlags['application_new_sidebar'] && props.sidebar ? _jsx(SideBarCard, {
            children: props.sidebar
          }) : _jsx(LegacySidebar, {
            application: application,
            permissions: permissions,
            isOpen: isSidebarOpen,
            setIsOpen: setIsSidebarOpen,
            reloadAggregatedData: reloadApplicationPageAggregatedData,
            reloadBaseApplication: reloadBaseApplication,
            onChangeIntakeSuccess: onChangeIntakeSuccess
          });
        },
        applicationStepper: featureFlags['application_apr_ats'] ? _jsx(ApplicationStepperCard, {
          ml: 4
        }) : undefined,
        LegacyApplicationStepper: featureFlags['application_apr_ats'] ? undefined : LegacyApplicationStepper,
        onSidebarOpenChange: setIsSidebarOpen,
        RPSelfEvaluation: RPSelfEvaluation,
        HybridRequirementDialogButton: HybridRequirementDialogButton,
        HybridRequirementPreviewMode: HybridRequirementPreviewMode,
        HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
        ActionsMenu: ActionsMenu,
        isRequirementEvaluationPending: isRequirementEvaluationPending,
        ApplicantRequirementList: showNewView ? RequirementList : undefined,
        AdminRequirementList: showNewView && showAprActionsTabFeatures ? RequirementList : undefined,
        renderNotesList: featureFlags['application_apr_notes'] ? function (_ref3) {
          var getTemplateString = _ref3.getTemplateString,
            noteType = _ref3.noteType;
          return _jsxs(ErrorBoundary, {
            fallbackRender: function fallbackRender(_ref4) {
              var error = _ref4.error;
              return _jsxs("div", {
                style: {
                  display: 'flex',
                  gap: '80px',
                  flexDirection: 'column'
                },
                children: [_jsx(Text, {
                  variant: "titleL",
                  children: noteType === 'customer' ? t('customerNotesTitle') : t('adminCommentsTitle')
                }), _jsx(IllustratedErrorState, {
                  error: error,
                  variant: "compact"
                })]
              });
            },
            onError: function onError(error) {
              return trackEvent({
                event: 'Single Application V2 - Notes Tab - Displayed Error',
                error: error
              });
            },
            children: [_jsx(NotesList, {
              noteType: noteType,
              showNotesTakeActionMenu: props.showNotesTakeActionMenu,
              onPrefillTemplate: function onPrefillTemplate(isPrivate, trackEvent) {
                return getTemplateString(isPrivate, trackEvent, canCreateBulkNote, true);
              },
              onStartLiveChat: props.onStartLiveChat
            }), _jsx("div", {
              id: "note-templates-modal-container"
            })]
          }, noteType);
        } : undefined,
        NewViewNotice: NewViewNotice,
        renderNewViewAdminToggle: function renderNewViewAdminToggle() {
          return showToggle ? _jsx(NewViewAdminToggle, {
            onChangeView: onChangeView,
            viewType: showNewView ? 'rp' : 'admin'
          }) : null;
        },
        hideApplicationRequirementsHeader: !!(showNewView && featureFlags['application_apr_admin_features']),
        hideAdminRequirementsHeader: !!(showNewView && showAprActionsTabFeatures),
        canCreateBulkNote: canCreateBulkNote,
        isMarkdownRendererEnabled: isMarkdownRendererEnabled
      })
    })
  });
}